import styled from '@emotion/styled';

import SkeletonLoading from '../../../../../shared/components/Loading/SkeletonLoading';

const Container = styled.div`
  padding: 12px 0 20px;
`;

const ProductList = styled.ul`
  display: flex;
  flex-wrap: wrap;
`;

const Product = styled.li`
  display: flex;
  width: 507px;
  padding-top: 24px;
  &:nth-of-type(2n) {
    margin-left: auto;
  }
`;

const Title = styled.div`
  width: 311px;
  padding: 9px 0 0 20px;
`;

const Price = styled.div`
  margin-top: 7px;
`;

const Cart = styled.div`
  margin-top: 18px;
  margin-left: auto;
`;

const More = styled.div`
  width: 516px;
  margin: 52px auto 0;
`;

const CollectionListArticleSkeleton = () => (
  <Container>
    <ProductList>
      {Array.from({ length: 4 }).map((_, i) => (
        <Product key={`item-${i}`}>
          <SkeletonLoading width={72} height={72} />
          <Title>
            <SkeletonLoading width={209} height={23} />
            <Price>
              <SkeletonLoading width={110} height={24} />
            </Price>
          </Title>
          <Cart>
            <SkeletonLoading width={104} height={36} />
          </Cart>
        </Product>
      ))}
    </ProductList>
    <More>
      <SkeletonLoading width={516} height={56} />
    </More>
  </Container>
);

export default CollectionListArticleSkeleton;
